import classnames from 'classnames';
import React from 'react';
import { Bar, Bars, Wrapper } from './TopBarSwitcher.style';

export type TopBarSwitcherProps = {
  children: React.ReactNode[];
  currentBarIndex: number;
};

export function TopBarSwitcher(props: TopBarSwitcherProps) {
  const { currentBarIndex } = props;

  const className = classnames(`index-${currentBarIndex}`, {});

  return (
    <Wrapper className='TopBarSwitcher-wrapper' data-testid='TopBarSwitcher-wrapper'>
      <Bars className={className}>
        <Bar>{props.children[0]}</Bar>
        <Bar>{props.children[1]}</Bar>
      </Bars>
    </Wrapper>
  );
}

export default TopBarSwitcher;
